import React, {createContext, useState, useEffect, useContext} from 'react'
import authorize from './helpers/authorize'
import { getCodeFromLocation } from './helpers/getCodeFromLocation'
import { fetchToken } from './helpers/fetchToken'
import { fetchRefreshToken } from './helpers/fetchRefreshToken';
import { removeCodeFromLocation } from './helpers/removeCodeFromLocation'
import { getVerifierState } from './helpers/getVerifierState'
import { removeStateFromStorage } from './helpers/removeStateFromStorage'
import { Image } from 'react-bootstrap';
import CClogo from '../Assets/CClogo.png';
import { Spinner } from 'react-activity';
import 'react-activity/dist/react-activity.css';
import {AES, enc}from 'crypto-js';
import Cookies from 'cookies-js';




export default ({
  clientId,
  clientSecret,
  provider,
  scopes = [],
  tokenEndpoint = `${provider}/token`,
  storage = sessionStorage,
  fetch = window.fetch,
  busyIndicator = <><div style={{ height: "100%",width: "100%",position:'absolute', overflow:'hidden'}}><div style={{
    //background: "#CCCCCC",
    display: 'flex',
    height: "100%",
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection:'column'}}><Image style={{alignSelf:'center',
    width: 150,
    height: 150}} src={CClogo} /><Spinner/></div></div></>
}) => {

  const context = createContext({})
  const {Provider} = context

  class Authenticated extends React.Component {
    static contextType = context
    componentDidMount() {
      const { ensureAuthenticated } = this.context
      ensureAuthenticated()
        
    }

    refreshTokenCall =() =>{
      const code = getCodeFromLocation({ location: window.location })
          const state = getVerifierState({ clientId, storage })
      if( Cookies.get("ccMsal")!= null){
        const refreshToken =  Cookies.get("ccMsal");
        //console.log("refreshToken",getRefreshToken);
      //   const decrypted = AES.decrypt(refreshToken, 'itsEncrypted');
      // const decryptedObject = decrypted.toString(enc.Utf8);
       
        const getRefreshToken = JSON.parse(refreshToken)
        const expireOn = getRefreshToken.expires_on
        var currentDate = new Date().getTime()/1000
        const currentEpoch = Math.round(currentDate)
        const dynamicTimeOut=Math.round(expireOn-currentEpoch)
        //alert(dynamicTimeOut)  dynamicTimeOut<700
       // console.log("refreshToken",getRefreshToken);
        if(dynamicTimeOut<300){
        setTimeout(() => {
          fetchRefreshToken({
            clientId, clientSecret, tokenEndpoint, code, state, fetch
          })
          .then()
          .then(() => {
            console.log("RefreshDone<<<<<<<<<<<<<<<<")
            //removeStateFromStorage({ clientId, storage })  
            const refreshToken =  sessionStorage.getItem("isAuthenticated")
            const decrypted = AES.decrypt(refreshToken, 'itsEncrypted');
          const decryptedObject = decrypted.toString(enc.Utf8);
            const getRefreshToken = JSON.parse(decryptedObject)
            sessionStorage.setItem("Decrypted Token",JSON.stringify(getRefreshToken))
          
          })
          .catch(e => {
            console.error(e)
            console.log(`Error fetching auth token from REFRESH Token API: ${e.message}`)
          })
          
  
         }, 500);
        }
        }
    }

    
    render() {
      this.refreshTokenCall();
      const { token } = this.context
      const { children } = this.props
      //console.log(this.context,"===========>>>>>>>>CONTEXT ToKeN")
      //return children
      //const token= sessionStorage.getItem("isAuthenticated")
      //const getRefreshToken = JSON.parse(token)
     // console.log(getRefreshToken,"<<<<<<<<>>>>>>>")
      if (!Cookies.get('msAL')) {
        return busyIndicator
      } else {
        return children
      }
    }
  }

  const useToken = () => {
    const { token } = useContext(context)
    if (!Cookies.get('msAL')) {
      console.warn(`Trying to useToken() while not being authenticated.\nMake sure to useToken() only inside of an <Authenticated /> component.`)
    }
    return token
  }

  return {
    AuthContext: ({children}) => {
      const [token, setToken] = useState(null)
      
      // if we have no token, but code and verifier are present,
      // then we try to swap code for token
      useEffect(() => {

        ///////////
        if (!Cookies.get('msAL')) {
          const code = getCodeFromLocation({ location: window.location })
          const state = getVerifierState({ clientId, storage })
          if (code && state) {
            fetchToken({
              clientId, clientSecret, tokenEndpoint, code, state, fetch
            })
            .then(setToken)
            .then(() => {
              removeCodeFromLocation()
             // removeStateFromStorage({ clientId, storage })  

              //Data Decryption
              
                const refreshToken =  sessionStorage.getItem("isAuthenticated")
               const decrypted = AES.decrypt(refreshToken, 'itsEncrypted');
             const decryptedObject = decrypted.toString(enc.Utf8);
               const getRefreshToken = JSON.parse(decryptedObject)
               sessionStorage.setItem("Decrypted Token",JSON.stringify(getRefreshToken))
             
             
            })
            .catch(e => {
              console.error(e)
              //alert(`Error fetching auth token: ${e.message}`)
            })
          }
        }
      }, [token])

      const ensureAuthenticated = () => {
        const code = getCodeFromLocation({ location: window.location })
        if (!Cookies.get('msAL') && !code) {
          authorize({provider, clientId, scopes})
        }
      }

      return (
        <Provider value={{token, ensureAuthenticated}}>
          {children}
        </Provider>
      )
    },
    Authenticated,
    useToken
  }
}
